// @flow weak

export { default as TabPanel }            from './TabPanel/TabPanel';
export { default as TabPanelHeader }      from './tabPanelHeader/TabPanelHeader';
export { default as TabPanelBody }        from './tabPanelBody/TabPanelBody';
export { default as TabPanelBodyContent } from './TabPanelBodyContent/tabPanelBodyContent';
export { default as TabPanelDemo }        from './TabPanelDemo';



// WEBPACK FOOTER //
// ./src/app/components/tabPanel/index.js